<template>
  <div id="app">
      <OpenGraph />
      <MainNavigation />
      <a id="kg__burger--anchor" class="target-burger"><ul class="buns"><li class="bun"></li> <li class="bun"></li></ul></a>
      <LogoComponent />
      <SocialMenu />
      <NewsLetter />
      <transition
        name='fade'
        mode="out-in"
        @beforeLeave="beforeLeave"
        @enter="enter"
        @afterEnter="afterEnter"
        >
        <router-view :key="$route.path" ref="router" >
        </router-view>
      </transition>
      <transition
        name='fade'
        mode="out-in"
        @beforeLeave="beforeLeave"
        @enter="enter"
        @afterEnter="afterEnter"
        >
        <router-view name="newsview" :key="$route.path" ref="router" />
      </transition>
    <BodyFooter />
    <SideBar />
  </div>
</template>
<script>
import OpenGraph from '@/components/OpenGraph.vue';
import MainNavigation from '@/components/nav/MainNavigation.vue';
import LogoComponent from '@/components/LogoComponent.vue';
import SocialMenu from '@/components/nav/SocialMenu.vue';
import NewsLetter from '@/components/NewsLetter.vue';
import SideBar from '@/components/SideBar.vue';
import BodyFooter from '@/components/BodyFooter.vue';
export default {
  data() {
    return {
    };
  },
  components:{
    OpenGraph,
    MainNavigation,
    LogoComponent,
    SocialMenu,
    NewsLetter,
    BodyFooter,
    SideBar
  },
  watch: {

  },
  methods:{
    beforeLeave(element) {
      //console.log("beforeLeave");
      jQuery('.menuopen').removeClass('menuopen');
    },
    enter(element) {
      //console.log("enter");
    },
    afterEnter(element) {
      //console.log("afterEnter");
    },
  },

}
</script>
<style>
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.67s;
  transition-property: opacity;
  transition-timing-function: ease;
  overflow: hidden;
}
.fade-enter-active{
  transition-delay: 1s;
}
.fade-enter,
.fade-leave-active {
  opacity: 0
}
.pagefooter {
    transition-duration: 0.67s;
    transition-property: opacity;
}
.fade-enter-active + .pagefooter,
.fade-enter + .pagefooter,
.fade-leave-active + .pagefooter {
    opacity: 0;
}
</style>
